import { makeHttpRequest } from "@/shared";

import { mapPaymentTypeFromServer } from "./mappers/mapPaymentTypesFromServer";

export const editPaymentType = async (id, paymentType) => {
    const response = (
        await makeHttpRequest({
            url: `/payment-type/${id}`,
            method: "PUT",
            data: paymentType,
        })
    ).data;

    return mapPaymentTypeFromServer(response.data);
};
